import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useOrdersStatisticsQuery = createQueryHook(OrderApiClient.getOrdersStatistics, {
  queryKey: ['getOrdersStatistics'],
})
